const en = {
  agree: 'agree',
  required: 'Required',
  optional: 'Optional',
  minutes: 'minutes',
  within_today: 'within today',
  see_more: 'View details',
  cannot_be_used_at_the_moment: 'Cannot be used at the moment.',
  the_page_may_be_temporarily_unavailable_or_the_link_might_have_been_removed: `The page may be temporarily unavailable or the link might have been removed.\nPlease try again after refreshing the page or waiting for a while.\nWe apologize for any inconvenience caused.`,
  error: {
    maximum_number_of_characters_exceeded:
      'Maximum number of characters exceeded',
    less_than_required_character_length: 'Less than required character length',
    contains_characters_that_cannot_be_used:
      'Contains characters that cannot be used',
    there_is_an_unanswered_question: 'Required fields remain unanswered.',
    an_item_was_not_filled_in_correctly: 'An item was not filled in correctly',
    our_server_is_very_busy_at_the_moment_please_come_back_after_a_while:
      'Our server is very busy at the moment. Please come back after a while.',
    server_is_unstable: 'Server is unstable',
  },
  btn: {
    refresh: 'Refresh',
  },
  please_wait_a_while_and_then_reload_the_app:
    'Please wait a while and then reload the app',
  preview_mode_cannot_submit_response:
    '*Cannot submit responses when in preview mode',
  warning_get_coupon_message: {
    message:
      'The coupon has not been issued yet.\n Please confirm the Terms & Conditions.',
  },
};

export default en;
